// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-module__title___2x2oU","closeButton":"styles-module__closeButton___2SudO"};